// extracted by mini-css-extract-plugin
export default {"statusDeactive":"styles_statusDeactive__vy-za","statusActive":"styles_statusActive__soCiy","row":"styles_row__X46Du"};